<script setup>
import { ref, onMounted, useSSRContext, watch } from 'vue'
import { useToast } from 'primevue/usetoast'
import axios from 'axios'
import { FilterMatchMode } from 'primevue/api'
import { useConfirm } from "primevue/useconfirm"
import Toast from 'primevue/toast'
import { useRouter } from 'vue-router'
import Company from './sub_components/Gartenkultur-Company.vue'
import Settings from './sub_components/Gartenkultur-CRM-Settings.vue'

const router = useRouter()
const loader = ref(false)
const toast = useToast()
const confirm = useConfirm()

const pipeline = ref("stRmVwTD")
const stages = ref([])
const deals = ref([])
const users = ref([])
const statuses = ref([])
const company_id = ref(null)

const company_slider = ref(false)
const company_slider_position = ref('right')
const settings_dialog = ref(false)

const filter_deals = ref({
    global: {value: null, matchMode: FilterMatchMode.CONTAINS},
    stage: {value: "", matchMode: FilterMatchMode.EQUALS}
})

onMounted( async () => {
    get_deals(pipeline.value)
    get_users()
    get_stages(pipeline.value)
})

const get_stages = (pipeline) => {
    loader.value = true
    axios.get(process.env.VUE_APP_NEURAXIS_API_MAIN + '/gartenkultur/crm/get-stages?pipeline=' + pipeline)
    .then(response => {
        console.log("stages", response.data)
        stages.value = response.data
        loader.value = false
    })
}

const show_settings = () => {
    settings_dialog.value = true
}

const get_deals = (pipeline) => {
    loader.value = true
    axios.get(process.env.VUE_APP_NEURAXIS_API_MAIN + '/gartenkultur/crm/get-deals?pipeline=' + pipeline)
    .then(response => {
        console.log("deals", response.data)
        deals.value = response.data
        loader.value = false
    })
}

const get_users = () => {
    loader.value = true
    axios.get(process.env.VUE_APP_NEURAXIS_API_MAIN + '/gartenkultur/crm/get-users')
    .then(response => {
        console.log(response.data)
        users.value = response.data
        loader.value = false
    })
}

const filter_status = (status) => {
    filter_deals.value.stage.value = status
    console.log(filter_deals.value)
}

const process_deal = (event) => {
    console.log(event.data)
    company_id.value = event.data.company_id
    company_slider.value = true
}

const get_user_first_name = (email) => {
    let first_name = ""
    let user = users.value.find(user => user.email == email)
    if (user) {
        first_name = user.first_name
    }
    return first_name
}

const open_url = (url) => {
    window.open(url, '_blank')
}

const format_swiss_date = (value) => {
    return value.substring(8,10) + '.' + value.substring(5,7) + '.' + value.substring(0,4)
}

const format_swiss_date_time = (value) => {
    return value.substring(8,10) + '.' + value.substring(5,7) + '.' + value.substring(0,4) + " " + value.substring(11,16)
}

const crm_tab_click = (event) => {
    console.log(event)
    let stage_name = stages.value[event.index].name
    filter_status(stage_name)
}

</script>
<style>

</style>
<style lang="scss" scoped>
    @import '@/core/assets/primevue/primeflex.scss';
</style>
<template>
    <ProgressSpinner v-if="loader" style="width:50px;height:50px" strokeWidth="8" animationDuration="1.5s" aria-label="Custom ProgressSpinner" class="spinner" />
    <Toast />
    <ConfirmDialog />
    <div>
        <TabView :scrollable="true" @tab-click="crm_tab_click" class="tabview-custom">
            <TabPanel v-for="stage in stages" :key="stage">
                <template #header>
                    <span class="mr-3 font-bold white-space-nowrap">{{ stage.name }}</span>
                    <Badge :value="String(stage.deals)" :severity="stage.deals > 0 ? 'contrast' : 'secondary'" />
                </template>
            </TabPanel>
        </TabView>
    </div>
    <Toolbar>
        <template #start>
            <span class="p-input-icon-left mr-2">
                <i class="pi pi-search" />
                <InputText v-model="filter_deals['global'].value" placeholder="Suche" class="w-full" @update:modelValue="filter_status('')" />
            </span>
            <Button label="Aktualisieren" icon="pi pi-refresh" @click="get_deals()" class="w-auto mr-2" v-tooltip.right="'Aktualisieren'" />
        </template>
        <template #end>
            <Button icon="pi pi-file-excel" @click="open_url(process.env.VUE_APP_NEURAXIS_API_MAIN + '/gartenkultur/crm/export-excel')" class="w-auto p-button-text mr-2" v-tooltip.left="'Übersicht als Excel exportieren'" />
            <Button icon="pi pi-cog" @click="show_settings" rounded class="mr-2 p-button-text" v-tooltip.left="'Einstellungen'" />
        </template>
    </Toolbar>
    <div rounded class="overflow-hidden shadow-3 border-200 mt-4">
        <DataTable class="mt-3" v-model:filters="filter_deals" @row-click="process_deal" :value="deals" :rows="200" responsiveLayout="scroll" :rowHover="true" :rowsPerPageOptions="[200,400,1000]" :paginator="true" paginatorTemplate="CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown" currentPageReportTemplate="{first} bis {last} von {totalRecords}">
            <Column field="add_time" header="Startdatum" sortable>
                <template #body="slotProps">
                    {{ format_swiss_date(slotProps.data.dc) }}
                </template>
            </Column>
            <Column field="name" header="Projekt">
                <template #body="slotProps">
                    <span class="font-bold">{{slotProps.data.name}}</span>
                </template>
            </Column>
            <Column field="owner" header="Planer">
                <template #body="slotProps">
                    <Chip icon="pi pi-user" v-if="slotProps.data.owner" :label="get_user_first_name(slotProps.data.owner)" class="mr-2 bg-primary text-white cursor-pointer" />
                    <i v-else class="pi pi-times text-red-800" v-tooltip.top="'Noch kein Planer!'" />
                </template>
            </Column>
            <Column field="update_time" header="Aktualisiert" sortable>
                <template #body="slotProps">
                    {{ format_swiss_date_time(slotProps.data.dm) }}
                </template>
            </Column>
            <Column header="Resourcen">
                <template #body="slotProps">
                    <Chip class="bg-primary text-white mr-2" icon="pi pi-user" :label="String(slotProps.data.total_contacts)" v-tooltip.bottom="'Kontakte'" />
                    <Chip class="bg-primary text-white mr-2" icon="pi pi-file-edit" :label="String(slotProps.data.total_activities)" v-tooltip.bottom="'Notizen'" />
                    <Chip hidden class="bg-primary text-white mr-2" icon="pi pi-paperclip" :label="String(slotProps.data.files)" v-tooltip.bottom="'Dateien'" />
                    <Chip hidden class="bg-red-700 text-white mr-2" icon="pi pi-bell" :label="String(0)" v-tooltip.bottom="'Kundenaufgaben'" />
                </template>
            </Column>
            <Column field="status" header="Status">
                <template #body="slotProps">
                    <Chip :label="slotProps.data.stage" class="bg-black-alpha-90 text-white font-bold cursor-pointer" />
                </template>
            </Column>
        </DataTable>
    </div>
    <!--------------------------------------------------------------------------->
    <!-------------------------------- Slider ---------------------------------->
    <!--------------------------------------------------------------------------->
    <Sidebar v-model:visible.sync="company_slider" :position="company_slider_position" style="width: 70%">
            <Company v-if="company_id" :company_id="company_id" />
    </Sidebar>
    <Dialog v-model:visible="settings_dialog" :style="{width: '70%'}" header="CRM Einstellungen" :modal="true" class="p-fluid z-5">
        <Settings channel="gartenkultur" />
    </Dialog>
</template>